.card {
  width: 160px;
  height: 160px;
  border-radius: 12px;
  background: var(--color-surface, #fff);
  border: 1px solid var(--color-border, #d8d8e0);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  padding: 14px;
  font-family: inherit;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  box-sizing: border-box;
}

.trigger {
  background: #fff3e6;
  border-color: #f59e0b;
}
.email {
  background: #e8f1fd;
  border-color: #2563eb;
}
.task {
  background: #e8f7ee;
  border-color: #16a34a;
}
.stage {
  background: #fff8d6;
  border-color: #eab308;
}
.form {
  background: #fde4ef;
  border-color: #d6336c;
}
.delay {
  border-color: #b45309;
}
.branch {
  border-color: #7c3aed;
}

.kind {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-muted, #6b6f80);
  margin: 0 0 4px 0;
}

.label {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text, #1a1a26);
  margin: 0;
  line-height: 1.25;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.subtitle {
  margin: 6px 0 0 0;
  font-size: 11px;
  color: var(--color-muted, #6b6f80);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.group {
  width: 100%;
  height: 100%;
  border: 1px dashed rgba(12, 12, 12, 0.18);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.55);
  position: relative;
  pointer-events: all;
}

.groupHeader {
  position: absolute;
  top: 12px;
  left: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--kh-text-primary, #0c0c0c);
}

.groupStatus {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex: 0 0 auto;
}
.groupStatusOn {
  background: var(--kh-teal, #1a8c68);
}
.groupStatusOff {
  background: var(--kh-text-muted, #888);
}

.groupTitle {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.groupRemove {
  background: transparent;
  border: none;
  font-size: 18px;
  line-height: 1;
  color: var(--kh-text-muted, #888);
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
}
.groupRemove:hover {
  background: rgba(237, 25, 67, 0.1);
  color: var(--kh-red, #ed1943);
}

.groupDirection {
  background: transparent;
  border: 1px solid var(--kh-border, rgba(0, 0, 0, 0.12));
  font-size: 14px;
  line-height: 1;
  color: var(--kh-text-secondary, #555);
  cursor: pointer;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 700;
  min-width: 24px;
}
.groupDirection:hover {
  background: var(--kh-off-white, #fef5f7);
  color: var(--kh-text-primary, #0c0c0c);
}

.linkHandle {
  width: 12px;
  height: 12px;
  background: var(--kh-accent, #d62a4a);
  border: 2px solid #fff;
  opacity: 0;
  pointer-events: none;
  transition:
    opacity 140ms ease,
    transform 120ms ease;
  z-index: 10;
}
:global(.react-flow__node[data-near]) .linkHandle {
  opacity: 0.7;
  pointer-events: all;
}
:global(.react-flow__node[data-near]) .linkHandle:hover {
  opacity: 1;
  transform: scale(1.4);
}
